import axios from '@/utils/http.js';

const urls = {
  overviewBymonth: '/user/overviewBymonth1',
  queryAbnormalAttendance: '/user/overviewBymonth4', // 异常考勤提醒
  queryOverview: '/user/overviewBymonth5', // 每月人天概览
  expoetAbnormalAttendance: '/user/overviewBymonth4Export', // 每月异常考勤导出
  expoetQueryOverview: '/user/overviewBymonth5Export', // 每月人天概览导出
  getBarGraph: '/user/overviewBymonth3', // 每月打卡柱状图
  getPieGraph: '/user/overviewBymonth2', // 每月打卡饼状图
  getDaysByMonth: '/user/getDaysByMonth',
  oneClickrepairRecord: '/user/oneClickrepairRecord', // 一键修复
};

export const overviewBymonth = function (options) {
  options.url = urls.overviewBymonth;
  return axios.get(options);
};
export const queryAbnormalAttendance = function (options) {
  options.url = urls.queryAbnormalAttendance;
  return axios.get(options);
};
export const queryOverview = function (options) {
  options.url = urls.queryOverview;
  return axios.get(options);
};
export const expoetAbnormalAttendance = function (options) {
  options.url = urls.expoetAbnormalAttendance;
  return axios.get(options);
};
export const expoetQueryOverview = function (options) {
  options.url = urls.expoetQueryOverview;
  return axios.get(options);
};
export const getBarGraph = function (options) {
  options.url = urls.getBarGraph;
  return axios.get(options);
};
export const getPieGraph = function (options) {
  options.url = urls.getPieGraph;
  return axios.get(options);
};

export const getDaysByMonth = function (options) {
  options.url = urls.getDaysByMonth;
  return axios.get(options);
};

export const oneClickrepairRecord = function (options) {
  options.url = urls.oneClickrepairRecord;
  return axios.get(options);
};
